const state = {
    sidebarOpen: false,
    user: {},
    toast: null,
    idPengajuanTerakhir: null,
    notifikasi: false,
    lastPage: null,
}

const getters = {
    baseUrl: state => state.settings || 'NotSet',
}

const mutations = {
    setSidebarOpen(state, val) {
        state.sidebarOpen = val
    },
    setUser(state, user) {
        state.user = user
    },
    toast(state, toast) {
        state.toast = toast
    },
    setIdPengajuanTerakhir(state, id) {
        state.idPengajuanTerakhir = id
    },
    setNotifikasi(state, val) {
        state.notifikasi = val
    },
    setLastPage(state, val) {
        state.lastPage = val
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/settings.js